import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/fn/array';
import 'core-js/fn/number';
import 'core-js/fn/object';
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import App from './containers/app';
import './index.css';
import { unregister } from './registerServiceWorker';
import store from './store';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)
unregister()



// WEBPACK FOOTER //
// ./src/index.js